<script>
export default {
  functional: true,
  render: (h, ctx) => ctx.children
}
</script>